<!-- frontend/src/components/PoliticaPrivacidad.vue -->
<template>
  <div class="container">
    <Electro3Menu />
    <div class="content">
      <h1>🛡️ Política de Privacidad – Electro3</h1>
      <p><strong>Última actualización:</strong> 5 de junio de 2025</p>

      <p>Electro3 se compromete a proteger la privacidad de sus usuarios. Esta política de privacidad describe cómo gestionamos la información en nuestra aplicación vinculada a la plataforma WhatsApp Business.</p>

      <h2>1. Recolección de datos</h2>
      <p>Electro3 no recolecta, almacena ni procesa datos personales de los usuarios. No utilizamos cookies ni tecnologías de seguimiento.</p>

      <h2>2. Uso de la plataforma WhatsApp</h2>
      <p>Utilizamos la API de WhatsApp Business únicamente con fines de comunicación directa con nuestros clientes sobre productos y servicios ofrecidos por Electro3 (repuestos eléctricos, baterías, luces, entre otros).</p>

      <h2>3. Acceso a información</h2>
      <p>La aplicación puede recibir ciertos datos básicos (como el número de teléfono) mediante la interacción en WhatsApp. Dichos datos no son almacenados ni compartidos por Electro3.</p>

      <h2>4. Seguridad</h2>
      <p>No accedemos ni almacenamos datos sensibles. Toda comunicación se realiza a través de canales seguros provistos por WhatsApp (Meta).</p>

      <h2>5. Contacto</h2>
      <p>Si tenés preguntas sobre esta política, podés escribirnos a:</p>
      <p>📧 <a href="mailto:dev@electro3.com.ar">dev@electro3.com.ar</a></p>
    </div>
    <Electro3Footer />
  </div>
</template>

<script>
import Electro3Menu from "@/components/Electro3Menu.vue";
import Electro3Footer from "@/components/Electro3Footer.vue";

export default {
  components: {
    Electro3Menu,
    Electro3Footer,
  },
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 2rem;
  color: #333;
}

h2 {
  font-size: 1.5rem;
  margin-top: 20px;
}

p {
  font-size: 1rem;
  color: #555;
}
</style>
